var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.toggleClick}},[_c('i',{staticClass:"el-icon-arrow-left",class:{'is-active':_vm.isActive}})])}
var staticRenderFns = []

export { render, staticRenderFns }